import Base from "./base.js";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  GET_PROFILE_ID,
  RESET_USER_PASSWORD,
  CHANGE_USER_PASSWORD,
  RESET_TOKEN_USER_PASSWORD,
  CHECK_TOKEN_USER_PASSWORD
} from "@/utils/api-url";

const CLUB_ROLES = ["clubHeadCoach", "premiumclubHeadCoach"];

export default class User extends Base {
  constructor(params = {}) {
    super(params);
    
    this.role = params['role'] || this.role || params['coachId'] && params['coachId']['role']
    this._id = params["_id"] || this.id || params['coachId'] && params['coachId']['id']
    this.username = params["username"] || this.username || params['coachId'] && params['coachId']['name']
  }

  static validationRules = {
    oldPassword: [{ required: true, message: "Old Password is required" }],
    newPassword: [{ required: true, message: "New Password is required" }],
    confirmPassword: [{ required: true, message: "Enter New password Again" }]
  };

  static resourceName() {
    return "User";
  }

  static getProfile() {
    return apiDispatcher(
      GET_PROFILE_ID({ userTypeUrl: User.userTypeUrl(), userId: User.userId() })
    );
  }

  static belongsToClub() {
    return CLUB_ROLES.includes(JSON.parse(localStorage["user-permissions"]));
  }

  static resetPassword(params) {
    return apiDispatcher(RESET_USER_PASSWORD(params));
  }

  static changePassword(params) {
    return apiDispatcher(CHANGE_USER_PASSWORD(params));
  }

  static resetTokenPassword(params) {
    return apiDispatcher(RESET_TOKEN_USER_PASSWORD(params))
  }

  static checkToken(params) {
    return apiDispatcher(CHECK_TOKEN_USER_PASSWORD(params))
  }
}
